import React, { JSX } from 'react'
import { Route, Routes } from 'react-router'
import Layout from 'components/Layout'
import { TotalsByEventPage } from 'pages/TotalsByEventPage'
import { withAuthenticationRequired } from '@auth0/auth0-react'

export const ROOT_PATH = '/'

const ProtectedRoute = ({ component, ...args }): JSX.Element => {
  const Component = withAuthenticationRequired(component, args)
  return <Component />
}

const Routing = (): JSX.Element => {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <ProtectedRoute component={Layout} />
}
      >
        <Route path={ROOT_PATH} element={<TotalsByEventPage />} />
      </Route>
    </Routes>
  )
}

export default Routing
